import GuestLayoutCompact from '@/Layouts/Guest/GuestLayoutCompact';
import PrimaryButton from '@/Components/PrimaryButton';
import {Head, Link, useForm} from '@inertiajs/react';
import {FormEventHandler} from 'react';
import toast from 'react-hot-toast';

export default function VerifyEmail({status, emailRecentlyChanged}: {
    status?: string,
    emailRecentlyChanged?: boolean
}) {
    const {post, processing} = useForm({});

    const submit: FormEventHandler = (e) => {
        e.preventDefault();

        post(route('verification.send'), {
            onError: (errors) => {
                if (errors.error) {
                    toast.error(errors.error);
                }
            },
        });
    };

    return (
        <GuestLayoutCompact>
            <Head title="Email Verification"/>

            <div className="mb-4 text-sm text-gray-600 dark:text-gray-400">
                Thanks for signing up! Before getting started, could you verify your email address by clicking on the
                link we just emailed to you? If you didn't receive the email, we will gladly send you another.
            </div>

            {status === 'verification-link-sent' && (
                <>
                    <div className="mb-4 font-medium text-sm text-green-600">
                        A new verification link has been sent to the email address you provided during registration.
                    </div>
                    <div className="mb-4 p-4 bg-yellow-50 dark:bg-yellow-900/20 border border-yellow-200 dark:border-yellow-800 rounded-md">
                        <p className="text-sm text-yellow-800 dark:text-yellow-200">
                            Please check your spam folder if you don't see the email in your inbox.
                        </p>
                    </div>
                </>
            )}

            <form onSubmit={submit}>
                <div className="mt-4 flex items-center justify-between">
                    <PrimaryButton className="me-2" disabled={processing}>Resend Verification Email</PrimaryButton>

                    <Link
                        href={route('logout')}
                        method="post"
                        as="button"
                        className="underline text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        Log Out
                    </Link>
                </div>
            </form>

            {emailRecentlyChanged && (
                <div className="mt-6 text-center border-t dark:border-gray-700 pt-3">
                    <p className="text-sm text-gray-600 dark:text-gray-400">
                        Wrong email address?{' '}
                        <Link
                            href={route('profile.edit')}
                            className="underline text-sm text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                        >
                            Update your profile
                        </Link>
                    </p>
                </div>
            )}
        </GuestLayoutCompact>
    );
}
